import classNames from "classnames";
import styles from "./style.module.scss";
import SkeletonLoader from "shared/components/common/skeleton";

interface ChatBoardCommentSkeletonProps {
  count?: number;
  className?: string;
}

const ChatBoardCommentSkeleton = ({
  count = 1,
  className,
}: ChatBoardCommentSkeletonProps) => {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          className={classNames(
            styles.commentSkeleton,
            "flex items-start gap-2",
            className,
          )}
        >
          <div className={classNames(styles.avatarSkeleton, "sm:absolute")}>
            <SkeletonLoader className={styles.avatar} />
          </div>

          <div className="sm:pl-12 w-full">
            <div className={styles.headerSkeleton}>
              <div className={styles.headerContent}>
                <div
                  className={classNames(
                    styles.senderInfo,
                    "flex items-center gap-2 flex-wrap",
                  )}
                >
                  <SkeletonLoader className={styles.senderName} />
                  <SkeletonLoader className={styles.badge} />
                  <SkeletonLoader className={styles.timestamp} />
                </div>
              </div>
            </div>
            <div className={styles.contentSkeleton}>
              <SkeletonLoader className={styles.messageLine1} />
              <SkeletonLoader className={styles.messageLine2} />
              <SkeletonLoader className={styles.messageLine3} />
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default ChatBoardCommentSkeleton;
